//CRN_20251218 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import { BulkUnreserveResultDTO } from 'src/app/core/models/system/reservation/bulk-unreserve-result.dto';
import CustomStore from 'devextreme/data/custom_store';
import { DeviceDTO } from 'src/app/core/models/system/device/device.dto';
import { EncryptionService } from '../../general/encryption-service';
import { environment } from 'src/environments/environment';
import { eSimApiPaths } from 'src/app/core/consts';
import { EsimProvisioningDTO } from 'src/app/core/models/system/provisioning/esim-provisoning.dto';
import { EsimReservationDTO } from 'src/app/core/models/system/reservation/esim-reservation.dto';
import { ExceptionsService } from '../../general/exceptions-service';
import { forkJoin, lastValueFrom, map, Observable, of, switchMap } from 'rxjs';
import { HttpClientService } from '../../general/http-client-service';
import { IdAndDescriptionDTO } from 'src/app/core/interfaces/general/id-description';
import { Injectable } from '@angular/core';
import { IntegerResultDTO } from 'src/app/core/interfaces/general/integer-result';
import { StringResultDTO } from 'src/app/core/interfaces/general/string-result';

@Injectable({ providedIn: 'root' })

export class DevicesService {
  
  constructor(
    private encryptionService: EncryptionService,
    private exceptionsService: ExceptionsService,
    private httpClientService: HttpClientService
  ) { }

  public allocate(id: number): Observable<any> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>id, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const idEncSS=encResult.result;
                            
                            return this.httpClientService.put(environment.eSimApi +
                                                              eSimApiPaths.Devices + "/" +
                                                              eSimApiPaths.DeviceAllocate +
                                                              "?idEncSS=" + idEncSS, undefined, {}); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  // public get(userId: number): Observable<DeviceDTO[]> {
  //   try {
  //     //CRN_20260123 - ⚠️ If reinstated ServerSideEncryption must be implemented ⚠️

  //     return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>userId)
  //            .pipe(
  //               switchMap((encResult: StringResultDTO) => {
  //                           const userIdEnc=encResult.result;
                            
  //                           return this.httpClientService.get<DeviceDTO[]>(environment.eSimApi +
  //                                                                          eSimApiPaths.Devices +
  //                                                                          "?userIdEnc=" + userIdEnc); 
  //                        })
  //                 );
  //   }
  //   catch(e) {
  //     this.exceptionsService.handleException(<Error>e);
  //     return of();
  //   }
  // }

  public simLimitChanged(iccid : string, updatedByUserId : number): Observable<number> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(iccid, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const iccidEncSS=encResult.result;
                            
                            return this.httpClientService.post(environment.eSimApi +
                                                               eSimApiPaths.Webbing + "/" +
                                                               eSimApiPaths.WebbingLimitChange +
                                                               "?iccidEncSS=" + iccidEncSS +
                                                               "&updatedByUserId=" + updatedByUserId,
                                                               iccidEncSS); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public bar(iccid : string, updatedByUserId : number): Observable<DeviceDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(iccid, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const iccidEncSS=encResult.result;
                            
                            return this.httpClientService.post(environment.eSimApi +
                                                               eSimApiPaths.Webbing + "/" +
                                                               eSimApiPaths.WebbingBar +
                                                               "?iccidEncSS=" + iccidEncSS +
                                                               "&updatedByUserId=" + updatedByUserId,
                                                               iccidEncSS); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
  
  public deprovision(iccid : string, updatedByUserId : number): Observable<DeviceDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(iccid, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const iccidEncSS=encResult.result;
                            
                            return this.httpClientService.post(environment.eSimApi +
                                                               eSimApiPaths.Webbing + "/" +
                                                               eSimApiPaths.WebbingDeprovision +
                                                               "?iccidEncSS=" + iccidEncSS +
                                                               "&updatedByUserId=" + updatedByUserId,
                                                               iccidEncSS); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getById(id: number): Observable<DeviceDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>id, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const idEncSS=encResult.result;
                            
                            return this.httpClientService.getById(environment.eSimApi +
                                                                  eSimApiPaths.Devices + "/" +
                                                                  eSimApiPaths.DevicesGetById +
                                                                  "?idEncSS=" + idEncSS, undefined); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getByImeiIccid(Iccid: string): Observable<DeviceDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(Iccid, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const iccidEncSS=encResult.result;
                            
                            return this.httpClientService.get<DeviceDTO>(environment.eSimApi +
                                                                         eSimApiPaths.Devices + "/" +
                                                                         eSimApiPaths.DevicesByImeiIccid +
                                                                         "?iccidEncSS=" + iccidEncSS); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getAvailableIdAndDescription(deviceTypeId :number, companyId :number, reservedOnly :boolean, availableOnly :boolean): Observable<IdAndDescriptionDTO[]> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>companyId, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const companyIdEncSS=encResult.result;
                            
                            return this.httpClientService.get<DeviceDTO[]>(environment.eSimApi +
                                                                           eSimApiPaths.Webbing + "/" +
                                                                           eSimApiPaths.DevicesGetAvailable +
                                                                           "?companyIdEncSS=" + companyIdEncSS +
                                                                           "&systemDeviceTypeId=" + deviceTypeId +
                                                                           "&reservedOnly=" + reservedOnly +
                                                                           "&availableOnly=" + availableOnly)
                                   .pipe(
                                     map(x => x.map(this.idAndDescriptionConverter))
                                   ); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getIdAndDescription(userId: number): Observable<IdAndDescriptionDTO[]> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>userId, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const userIdEncSS=encResult.result;
                            
                            return this.httpClientService.get<DeviceDTO[]>(environment.eSimApi +
                                                                           eSimApiPaths.Devices +
                                                                           "?userIdEncSS=" + userIdEncSS)
                                   .pipe(
                                     map(x => x.map(this.idAndDescriptionConverter))
                                   ); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getIdAndDescriptionForCompany(companyId : number | undefined): Observable<IdAndDescriptionDTO[]> {
    try {
      companyId=companyId ?? -1;
      
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>companyId, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const companyIdEncSS=encResult.result;
                            
                            return this.httpClientService.get<DeviceDTO[]>(environment.eSimApi +
                                                                           eSimApiPaths.Devices + "/" +
                                                                           eSimApiPaths.DevicesForCompany +
                                                                           "?companyIdEncSS=" + companyIdEncSS)
                                   .pipe(
                                     map(x => x.map(this.idAndDescriptionConverter))
                                   ); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getIdAndDescriptionForHierarchy(companyId : number | undefined): Observable<IdAndDescriptionDTO[]> {
    try {
      companyId=companyId ?? -1;
      
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>companyId, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const companyIdEncSS=encResult.result;
                            
                            return this.httpClientService.get<DeviceDTO[]>(environment.eSimApi +
                                                                           eSimApiPaths.Devices + "/" +
                                                                           eSimApiPaths.DevicesForHierarchy +
                                                                           "?companyIdEncSS=" + companyIdEncSS)
                                   .pipe(
                                     map(x => x.map(this.idAndDescriptionConverter))
                                   ); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getIdAndDescriptionForUser(userId : number | undefined): Observable<IdAndDescriptionDTO[]> {
    try {
      userId=userId ?? -1;
      
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>userId, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const userIdEncSS=encResult.result;
                            
                            return this.httpClientService.get<DeviceDTO[]>(environment.eSimApi +
                                                                           eSimApiPaths.Devices + "/" +
                                                                           eSimApiPaths.DevicesForUser +
                                                                           "?userIdEncSS=" + userIdEncSS)
                                   .pipe(
                                     map(x => x.map(this.idAndDescriptionConverter))
                                   ); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getIdAndDescriptionForLoggedInUser(userId : number): Observable<IdAndDescriptionDTO[]> {
    //TODO update this routine to only show devices for the logged in user
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>userId, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const userIdEncSS=encResult.result;
                            
                            return this.httpClientService.get<DeviceDTO[]>(environment.eSimApi +
                                                                           eSimApiPaths.Devices +
                                                                           "?userIdEncSS=" + userIdEncSS)
                                   .pipe(
                                     map(x => x.map(this.idAndDescriptionConverter))
                                   ); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getNextAvailableDevice(userId: number): Observable<DeviceDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>userId, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const userIdEncSS=encResult.result;
                            
                            return this.httpClientService.get<DeviceDTO>(environment.eSimApi +
                                                                         eSimApiPaths.Devices + "/" +
                                                                         eSimApiPaths.DeviceGetNextAvailable +
                                                                         "?userIdEncSS=" + userIdEncSS); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public bulkProvision(bulkOrderGuid : string, processDate : Date): Observable<DeviceDTO> {
    try {
      return this.httpClientService.post(environment.eSimApi + eSimApiPaths.Webbing + "/" + eSimApiPaths.WebbingProvisionBulk+ "?bulkProvisioningGuid=" + bulkOrderGuid + "&processDate=" + processDate, "");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public bulkProvisionInitialise(bulkOrderGuid : string, orderId : number | undefined = undefined): Observable<Date> {
    try {
      let ordId = (orderId == undefined ? -1 : orderId);
      return this.httpClientService.post(environment.eSimApi + eSimApiPaths.Webbing + "/" + eSimApiPaths.WebbingProvisionBulkInitialise+ "?bulkProvisioningGuid=" + bulkOrderGuid + "&orderID=" + ordId, "");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public stopBulkProvisioning(bulkOrderGuid : string): Observable<IntegerResultDTO> {
    try {
      return this.httpClientService.post(environment.eSimApi + eSimApiPaths.Webbing + "/" + eSimApiPaths.WebbingStopProvisionBulk + "?bulkProvisioningGuid=" + bulkOrderGuid, "");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public bulkUnreserveDevices(iccids : string[], companyId : number): Observable<BulkUnreserveResultDTO> {
    try {
      return forkJoin({
               companyIdEncResult: this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>companyId),
               iccidsEncSSResult : this.encryptionService.encrypt_AesServerSideForWeb(JSON.stringify(iccids), true)
             })
             .pipe(
               switchMap(({ companyIdEncResult, iccidsEncSSResult }) => {
                 const companyIdEnc=companyIdEncResult.result;
                 const iccidsEncSS =iccidsEncSSResult.result;

                 return this.httpClientService.post(environment.eSimApi
                                                    + eSimApiPaths.Webbing
                                                    + "/"
                                                    + eSimApiPaths.WebbingBulkUnreserveSims
                                                    + "?companyIdEnc=" + companyIdEnc,
                                                    { data: iccidsEncSS }
                                                   );
               })
             );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public bulkUpdateInviewToMatch(bulkOrderGuid : string): Observable<IntegerResultDTO> {
    try {
      return this.httpClientService.post(environment.eSimApi + eSimApiPaths.Webbing + "/" + eSimApiPaths.WebbingUpdateInviewToMatch + "?bulkProvisioningGuid=" + bulkOrderGuid, "");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public bulkCreateUsersOnly(bulkOrderGuid : string): Observable<IntegerResultDTO> {
    try {
      return this.httpClientService.post(environment.eSimApi + eSimApiPaths.Webbing + "/" + eSimApiPaths.WebbingBulkCreateUsersOnly + "?bulkProvisioningGuid=" + bulkOrderGuid, "");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public bulkReserveSims(bulkOrderGuid : string): Observable<IntegerResultDTO> {
    try {
      return this.httpClientService.post(environment.eSimApi + eSimApiPaths.Webbing + "/" + eSimApiPaths.WebbingBulkReserveSims + "?bulkProvisioningGuid=" + bulkOrderGuid, "");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public bulkClearErrors(bulkOrderGuid : string): Observable<IntegerResultDTO> {
    try {
      return this.httpClientService.post(environment.eSimApi + eSimApiPaths.Webbing + "/" + eSimApiPaths.WebbingClearBulkErrors + "?bulkProvisioningGuid=" + bulkOrderGuid, "");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
  public EnableLocationServices(companyId:number): Observable<Boolean> {
    try {
      return forkJoin({
               encResult       : this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>companyId, true)
             })
             .pipe(
               switchMap(({ encResult }) => {
                 const companyIdEncSS = encResult.result;
                 
                 return this.httpClientService.post(environment.eSimApi + 
                                                    eSimApiPaths.Devices + "/" + 
                                                    eSimApiPaths.DevicesEnableLocationServices +
                                                    "?companyIdEncSS="+ companyIdEncSS,
                                                    ""
                                                   );
               })
             );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public lockImei(iccid:string, imei:string, updatedByUserId : number): Observable<Boolean> {
    try {
      return forkJoin({
               iccidEncResult       : this.encryptionService.encrypt_AesServerSideForWeb(iccid, true),
               imeiEncResult        : this.encryptionService.encrypt_AesServerSideForWeb(imei),
               updatedByUserIdResult: this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>updatedByUserId)
             })
             .pipe(
               switchMap(({ iccidEncResult, imeiEncResult, updatedByUserIdResult }) => {
                 const iccidEncSS        =iccidEncResult.result;
                 const imeiEnc           =imeiEncResult.result;
                 const updatedByUserIdEnc=updatedByUserIdResult.result;
                 
                 return this.httpClientService.post(environment.eSimApi + 
                                                    eSimApiPaths.Webbing + "/" + 
                                                    eSimApiPaths.WebbingLockImei +
                                                    "?iccidEncSS="+ iccidEncSS +
                                                    "&imeiEnc=" + imeiEnc +
                                                    "&updatedByUserIdEnc=" + updatedByUserIdEnc,
                                                    ""
                                                   );
               })
             );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public provisionNextAvailableDevice(esimProvisioningDTO : EsimProvisioningDTO): Observable<DeviceDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(JSON.stringify(esimProvisioningDTO))
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const provisioningrequestEnc=encResult.result;
                            
                            return this.httpClientService.post(environment.eSimApi +
                                                               eSimApiPaths.Webbing + "/" +
                                                               eSimApiPaths.WebbingProvisionNextAvailableSim +
                                                               "?provisioningrequestEnc=" + provisioningrequestEnc, {}); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public reserveNextAvailableDevice(esimReservationDTO : EsimReservationDTO): Observable<DeviceDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(JSON.stringify(esimReservationDTO))
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const reservationRequestEnc=encResult.result;
                            
                            return this.httpClientService.post(environment.eSimApi +
                                                               eSimApiPaths.Webbing + "/" +
                                                               eSimApiPaths.WebbingReserveNextAvailableSim +
                                                               "?reservationRequestEnc=" + reservationRequestEnc, {}); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public sendManualActivationDetails(bulkOrderGuid : string): Observable<IntegerResultDTO> {
    try {
      return this.httpClientService.post(environment.eSimApi + eSimApiPaths.Webbing + "/" + eSimApiPaths.WebbingSendManualActivationDetails + "?bulkProvisioningGuid=" + bulkOrderGuid, "");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public toggleLocationServices(userId: number): Observable<Boolean> {
    try {
      return forkJoin({
               userIdEncResult      : this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>userId, true)
             })
             .pipe(
               switchMap(({ userIdEncResult }) => {
                 const userIdEncSS       =userIdEncResult.result;

                 return this.httpClientService.post(environment.eSimApi +
                                                    eSimApiPaths.Devices + "/" +
                                                    eSimApiPaths.DevicesToggleLocationServices +
                                                    "?userIdEncSS="+ userIdEncSS,
                                                    ""
                                                   );
               })
             );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public updateLocationSettings(userId                  : number,
                                locationSettingsOverride: boolean,
                                accuracyLevel           : number,
                                lastLocationOnly        : boolean,
                                reason                  : string=''): Observable<Boolean> {
    try {
      return forkJoin({
               userIdEncResult: this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>userId, true)
             })
             .pipe(
               switchMap(({ userIdEncResult }) => {
                 const userIdEncSS=userIdEncResult.result;

                 return this.httpClientService.post(environment.eSimApi +
                                                    eSimApiPaths.Devices + "/" +
                                                    eSimApiPaths.DevicesUpdateLocationSettings +
                                                    "?userIdEncSS="               + userIdEncSS +
                                                    "&locationSettingsOverride="  + locationSettingsOverride +
                                                    "&accuracyLevel="             + accuracyLevel +
                                                    "&lastLocationOnly="          + lastLocationOnly +
                                                    ((reason ?? '').trim()!='' ? "&reason=" + encodeURIComponent(reason.trim()) : ""),
                                                    ""
                                                   );
               })
             );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public unreserveDevice(iccid : string, companyId : number): Observable<Boolean> {
    try {
      return forkJoin({
               iccidEncResult    : this.encryptionService.encrypt_AesServerSideForWeb(iccid, true),
               companyIdEncResult: this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>companyId)
             })
             .pipe(
               switchMap(({ iccidEncResult, companyIdEncResult }) => {
                 const iccidEncSS  =iccidEncResult.result;
                 const companyIdEnc=companyIdEncResult.result;
                 
                 return this.httpClientService.post(environment.eSimApi + 
                                                    eSimApiPaths.Webbing + "/" + 
                                                    eSimApiPaths.WebbingUnreserveSim +
                                                    "?iccidEncSS="   + iccidEncSS +
                                                    "&companyIdEnc=" + companyIdEnc,
                                                    ""
                                                   );
               })
             );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public updateDeviceTag(iccid:string, tag:string, updatedByUserId : number): Observable<Boolean> {
    try {
      return forkJoin({
               iccidEncResult       : this.encryptionService.encrypt_AesServerSideForWeb(iccid, true),
               tagEncResult         : this.encryptionService.encrypt_AesServerSideForWeb(tag),
               updatedByUserIdResult: this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>updatedByUserId)
             })
             .pipe(
               switchMap(({ iccidEncResult, tagEncResult, updatedByUserIdResult }) => {
                 const iccidEncSS        =iccidEncResult.result;
                 const tagEnc            =tagEncResult.result;
                 const updatedByUserIdEnc=updatedByUserIdResult.result;
                 
                 return this.httpClientService.post(environment.eSimApi + 
                                                    eSimApiPaths.Devices + "/" + 
                                                    eSimApiPaths.DevicesUpdateDeviceTag +
                                                    "?iccidEncSS="+ iccidEncSS +
                                                    "&tagEnc=" + tagEnc +
                                                    "&updatedByUserIdEnc=" + updatedByUserIdEnc,
                                                    ""
                                                   );
               })
             );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  private idAndDescriptionConverter(device: DeviceDTO) {
    return {id: device.id, description: device.imeiIccid};
  }

  public idAndDescriptionLookupDataSource(userId: number): {} {
    try {
      return {
        store: new CustomStore({
          key: "id",
          loadMode: "raw",
          load: () => {
            return lastValueFrom(this.getIdAndDescription(userId));
          }
        }),
        sort: "description"
    };
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return {};
    }
  }

  public removeAlertProductSim(iccid : string, updatedByUserId : number): Observable<DeviceDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(iccid, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const iccidEncSS=encResult.result;
                            
                            return this.httpClientService.post(environment.eSimApi +
                                                               eSimApiPaths.Webbing + "/" +
                                                               eSimApiPaths.WebbingRemoveAlertProduct + 
                                                               "?iccidEncSS=" + iccidEncSS +
                                                               "&updatedByUserId=" + updatedByUserId,
                                                               iccidEncSS); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public suspend(iccid : string, updatedByUserId : number): Observable<DeviceDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(iccid, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const iccidEncSS=encResult.result;
                            
                            return this.httpClientService.post(environment.eSimApi +
                                                               eSimApiPaths.Webbing + "/" +
                                                               eSimApiPaths.WebbingSuspend +
                                                               "?iccidEncSS=" + iccidEncSS +
                                                               "&updatedByUserId=" + updatedByUserId,
                                                               iccidEncSS);
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public throttle(iccid : string, throttleSpeedTypeId : number, updatedByUserId : number): Observable<DeviceDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(iccid, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const iccidEncSS=encResult.result;
                            
                            return this.httpClientService.post(environment.eSimApi +
                                                               eSimApiPaths.Webbing + "/" +
                                                               eSimApiPaths.WebbingThrottle +
                                                               "?iccidEncSS=" + iccidEncSS + 
                                                               "&throttleSpeedTypeId=" + throttleSpeedTypeId +
                                                               "&updatedByUserId=" + updatedByUserId,
                                                               iccidEncSS);
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
  
  public totalLiveDevicesForCompany(companyId: number): Observable<IntegerResultDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>companyId, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const companyIdEncSS=encResult.result;
                            
                            return this.httpClientService.getByDescription(environment.eSimApi +
                                                                           eSimApiPaths.Devices + "/" +
                                                                           eSimApiPaths.DevicesTotalLiveDevicesForCompany +
                                                                           "?companyIdEncSS=", companyIdEncSS); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public unbar(iccid : string, updatedByUserId : number): Observable<DeviceDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(iccid, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const iccidEncSS=encResult.result;
                            
                            return this.httpClientService.post(environment.eSimApi +
                                                               eSimApiPaths.Webbing + "/" +
                                                               eSimApiPaths.WebbingUnbar +
                                                               "?iccidEncSS=" + iccidEncSS +
                                                               "&updatedByUserId=" + updatedByUserId,
                                                               iccidEncSS);
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public unsuspend(iccid : string, updatedByUserId : number): Observable<DeviceDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(iccid, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const iccidEncSS=encResult.result;
                            
                            return this.httpClientService.post(environment.eSimApi +
                                                               eSimApiPaths.Webbing + "/" +
                                                               eSimApiPaths.WebbingEnable +
                                                               "?iccidEncSS=" + iccidEncSS +
                                                               "&updatedByUserId=" + updatedByUserId,
                                                               iccidEncSS);
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public unthrottle(iccid : string, updatedByUserId : number): Observable<DeviceDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(iccid, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const iccidEncSS=encResult.result;
                            
                            return this.httpClientService.post(environment.eSimApi +
                                                               eSimApiPaths.Webbing + "/" +
                                                               eSimApiPaths.WebbingUnthrottle +
                                                               "?iccidEncSS=" + iccidEncSS +
                                                               "&updatedByUserId=" + updatedByUserId,
                                                               iccidEncSS);
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
}
